import { render, staticRenderFns } from "./PaginationControls.vue?vue&type=template&id=fbfdc080&scoped=true&"
import script from "./PaginationControls.vue?vue&type=script&lang=js&"
export * from "./PaginationControls.vue?vue&type=script&lang=js&"
import style0 from "./PaginationControls.vue?vue&type=style&index=0&id=fbfdc080&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbfdc080",
  null
  
)

export default component.exports